import { IAffiliate } from '@clickster/constant-definitions/dist-esm/entities/affiliate/types';
import { fetchAllPaginated } from '@/src/services/utils/fetch-all-paginated';
import { API_V2 } from '@/src/lib/axios';

const AFFILIATE_ENDPOINT = '/affiliates';

/**
 * Fetches all affiliate networks for use in the Spotlight search component.
 * Results are filtered client-side since affiliate networks are a small dataset.
 * @returns {Promise<IAffiliate[]>} All available affiliate networks.
 */
export const fetchSpotlightAffiliateNetworks = async (): Promise<IAffiliate[]> => {
  return fetchAllPaginated<IAffiliate>(API_V2, AFFILIATE_ENDPOINT, {});
};

/**
 * Filters a list of affiliate networks by a search query against name and platform.
 * @param {IAffiliate[]} networks - The full list of affiliate networks.
 * @param {string} query - The search query string.
 * @returns {IAffiliate[]} The filtered list of affiliate networks.
 */
export const filterAffiliateNetworks = (networks: IAffiliate[], query: string): IAffiliate[] => {
  if (!query || !networks.length) return networks;
  const lower = query.toLowerCase();

  return networks.filter(
    (network) =>
      network?.name?.toLowerCase().includes(lower) ||
      network?.api_configuration?.platform?.toLowerCase().includes(lower),
  );
};
